import { Fragment } from 'react';
import { formatTime } from '../../../../commom/formatTime';
import { Typography } from '../../../molecules/Typography';

interface IPodcastContent {
  time: string | number;
}

export function PodcastContent({ time }: IPodcastContent) {
  return (
    <Fragment>
      <Typography
        size='small'
        className='transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {typeof time === 'string' ? time : formatTime(time)}
      </Typography>
    </Fragment>
  );
}
